module.exports = __webpack_public_path__ + "static/media/check.a157969b.svg";